<script lang="ts">
	import { format_money_$_with_optional_cents } from 'shared/format_currency'
	import { micromark } from 'micromark'
	import fnum from 'shared/number'

	import ProductImage from './ProductImage.svelte'
	import SaleFlash from 'shared/component/SaleFlash.svelte'

	export let holster_line: ResourceTypes[`holster_line`] & { holster_availability_ref?: number }
	export let promo_active: boolean = false

	$: ({ base_price, promo_discount_rate } = holster_line.attributes)
	$: product_id = holster_line.relationships.product.data.id

	$: href = `/?p=${ product_id }${ holster_line.holster_availability_ref ? `&holster_availability_ref=${ holster_line.holster_availability_ref }` : `` }`

	$: price = promo_active
		? fnum(base_price).minus(fnum(base_price).times(promo_discount_rate))
		: fnum(base_price)

</script>

<li>
	<div class=image>
		<a href={href}>
			<ProductImage
				file_path={holster_line.attributes.product_category_image_path}
				alt={holster_line.attributes.product_category_image_alt}
			/>
		</a>
		{#if promo_active && Number(promo_discount_rate) > 0}
			<div class=sale_flash>
				<SaleFlash {promo_discount_rate} />
			</div>
		{/if}
	</div>

	<a href={href} class=name>
		{holster_line.attributes.name}
	</a>

	<div class=price>
			{#if !price.equal(base_price)}
				<del style="color: var(--disabled-gray)">{format_money_$_with_optional_cents(base_price)}+</del>
			{/if}
			{format_money_$_with_optional_cents(price)}+
	</div>

	<div class=bullets>
		{holster_line.attributes.product_category_bullets}
	</div>

	<div class="description">
		{@html micromark(holster_line.attributes.product_category_description_md || ``)}
	</div>
</li>

<style>
	li {
		--gap: 1rem;
		--image-min-size: min(200px, 40vw);
		background-color: var(--black);
		display: grid;

		grid-template-columns:
			[image-start] var(--gap)
			[full-width-content-start] calc(var(--image-min-size) - var(--gap))
			[image-end] var(--gap)
			[right-content-start] auto
			[name-end] var(--gap)
			[price-start] 10rem
			[content-end] var(--gap);

		grid-template-rows:
			[absolute-top] var(--gap)
			[vertical-content-start] min-content
			[bullet-start] min-content var(--gap)
			[right-description-start] 1fr
			[small-screen-image-end] var(--gap)
			[full-width-description-start] auto
			[vertical-content-end] var(--gap)
			[absolute-bottom];
	}

	.name, .price {
		font-size: 2rem;
		line-height: 1.2;
	}

	.image {
		position: relative;
		grid-column: image-start / image-end;
		grid-row: absolute-top / absolute-bottom;
		--cut-size: 10%;
		clip-path: polygon(0% 0%, 100% 0%, 100% 0%, 100% calc(100% - var(--cut-size)), calc(100% - var(--cut-size)) 100%, 0% 100%, 0% calc(100% - var(--cut-size)), 0% var(--cut-size));
	}

	.sale_flash {
		position: absolute;
		top: 0;
		left: 0;
		--font-size: 20px;
		--mobile-font-size: 4vw;
	}

	.name {
		grid-column: right-content-start / name-end;
		grid-row: vertical-content-start;
	}

	.price {
		grid-column: price-start;
		grid-row: vertical-content-start;
		justify-self: end;
		white-space: nowrap;
		text-align: right;
		color: white;
	}

	.bullets {
		color: var(--contrast-text);
		font-size: .8rem;

		grid-column: right-content-start / content-end;
		grid-row: bullet-start;
	}

	.description {
		grid-column: right-content-start / content-end;
		grid-row: right-description-start / vertical-content-end;
	}

	.description :global(p) {
		margin: 0;
	}

	@media (max-width: 600px) {
		li {
			--gap: .5rem;
		}

		.name, .price {
			font-size: 1.5rem;
		}

		.name {
			grid-column-end: content-end;
		}

		.image {
			grid-row-end: small-screen-image-end;
		}

		.description {
			grid-column-start: full-width-content-start;
			grid-row-start: full-width-description-start;
		}

		.price {
			grid-row: right-description-start;
			justify-self: unset;
		}
	}

	@media (max-width: 500px) {
		li {
			--image-min-size: 40vw;
		}
	}
</style>
